import React from 'react'
import { styled } from '@mui/material'
import { Typography as TypographyBase } from '@chilecompra/react-kit/components'

export const Root = styled('div')`
  align-items: center;
  display: flex;
  height: 46px;
  justify-content: center;
  margin: ${props => props.margin};
  position: relative;
  transition: opacity 0.5s ease;
  width: 80%;

  &:hover > * {
    opacity: 0.8;
  }

  &:hover > *:hover {
    opacity: 1;
  }
`
export const LeftBar = styled(({ activeBar, maxWidth, percentage, ...props }) => <div {...props} />)`
  background-color: ${props => props.theme.palette.charts.seance};
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  cursor: pointer;
  height: 46px;
  max-width: ${props => props.maxWidth};
  min-width: 182px;
  opacity: ${props => (props.activeBar === 'rightBar' ? '.4 !important' : '1')};
  transition: all 0.5s ease;
  width: ${props => props.percentage}%;

  & p {
    text-decoration: underline;
  }
`

export const RightBar = styled(({ activeBar, maxWidth, percentage, ...props }) => <div {...props} />)`
  background-color: ${props => props.theme.palette.charts.toryBlue};
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  height: 46px;
  max-width: ${props => props.maxWidth};
  min-width: 182px;
  opacity: ${props => (props.activeBar === 'leftBar' ? '.4 !important' : '1')};
  transition: all 0.5s ease;
  width: ${props => props.percentage}%;

  & p {
    text-decoration: underline;
  }
`

export const Typography = styled(({ alignItems, display, ...props }) => <TypographyBase {...props} />)`
  &.MuiTypography-root {
    align-items: ${props => props.alignItems};
    display: ${props => props.display};
  }
`

export const Strong = styled('strong')``
